import { VApp } from './VApp';

export default VApp;